import customer from "./customer_icon_24px.png";

export const CustomerIcon = () => (
  <img src={customer} height={24} width={24} alt="Customer icon" />
);
